import { IsUUID, IsNotEmpty } from 'class-validator';

export class GetTemplatesListDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;
}
